// Authcontext.js
import { createContext, useContext, useEffect, useState } from "react";
import { auth, db } from "../firebase/config";
import { onAuthStateChanged } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const unsubAuth = onAuthStateChanged(auth, (currentUser) => {
      if (!currentUser) {
        setUser(null);
        return;
      }

      const base = {
        uid: currentUser.uid,
        email: currentUser.email || "",
        emailLower: (currentUser.email || "").toLowerCase(),
      };

      // Provisional
      setUser(base);

      // ✅ Single source of truth for identity
      const stopUser = onSnapshot(
        doc(db, "users", currentUser.uid),
        (snap) => {
          if (!snap.exists()) {
            // Auth user exists but profile doc missing
            setUser(base);
            return;
          }

          setUser({ ...base, ...snap.data() });
        },
        (err) => {
          console.error("users onSnapshot error:", err);
          setUser(base);
        },
      );

      return stopUser;
    });

    return unsubAuth;
  }, []);

  const loading = user === undefined;

  return (
    <AuthContext.Provider value={{ user, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
